import { Resolution, Timespan } from '../model';

export interface TimespanConfig {
  value: Timespan;
  label: string;
  allowedResolutions: Resolution[];
  defaultResolution: Resolution;
}

type TimespanConfigDictionary = { [P in Timespan]: TimespanConfig };
type TimespanConfigArray = TimespanConfig[];

const dictionary: TimespanConfigDictionary = {
  [Timespan.FiveMinutes]: {
    value: Timespan.FiveMinutes,
    label: '5m',
    allowedResolutions: [Resolution.FiveMinutes],
    defaultResolution: Resolution.FiveMinutes,
  },
  [Timespan.Hour]: {
    value: Timespan.Hour,
    label: '1H',
    allowedResolutions: [Resolution.FiveMinutes],
    defaultResolution: Resolution.FiveMinutes,
  },
  [Timespan.Day]: {
    value: Timespan.Day,
    label: '1D',
    allowedResolutions: [Resolution.FiveMinutes, Resolution.Hour, Resolution.SixHours],
    defaultResolution: Resolution.Hour,
  },
  [Timespan.Week]: {
    value: Timespan.Week,
    label: '1W',
    allowedResolutions: [Resolution.FiveMinutes, Resolution.Hour, Resolution.SixHours, Resolution.Day],
    defaultResolution: Resolution.SixHours,
  },
  [Timespan.Month]: {
    value: Timespan.Month,
    label: '1M',
    allowedResolutions: [Resolution.Hour, Resolution.SixHours, Resolution.Day, Resolution.Week],
    defaultResolution: Resolution.Day,
  },
  [Timespan.Year]: {
    value: Timespan.Year,
    label: '1Y',
    allowedResolutions: [Resolution.SixHours, Resolution.Day, Resolution.Week],
    defaultResolution: Resolution.Week,
  },
};

export const TimespanConfigs: TimespanConfigArray = Object.values(dictionary);

export const getTimespanConfig = (timespan: Timespan): TimespanConfig => {
  if (!Object.keys(dictionary).includes(timespan)) {
    throw new Error('Invalid timespan provided.');
  }

  return dictionary[timespan];
};
